module.exports = __webpack_public_path__ + "static/img/img15.208565a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img15.png
// module id = 3nhU
// module chunks = 1